<template>
  <EntryCard :entry="entry">
  <template slot="text">
    <span class="text--disabled overline mr-2">Oracle</span>
    <span class="text--secondary">{{ entry.result.oracleTitle }}</span>:
    <span class="font-weight-bold">{{ entry.result.result }}</span>
  </template>
  </EntryCard>
</template>

<script>
  import EntryCard from '@/components/entry/EntryCard'
  export default {
    components: { EntryCard },
    props: {
      entry: {
        type: Object,
      },
    },
  };
</script>
